import { render, staticRenderFns } from "./Frmwalletsmaster.vue?vue&type=template&id=83a34ec4&"
import script from "./Frmwalletsmaster.vue?vue&type=script&lang=js&"
export * from "./Frmwalletsmaster.vue?vue&type=script&lang=js&"
import style0 from "./Frmwalletsmaster.vue?vue&type=style&index=0&id=83a34ec4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports